import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./AuthProvider";
import Auth from "./routes/Auth";
//import Home from "./routes/Home";
import NoMatch from "./routes/NoMatch";
import DealerOn from "./routes/DealerOn";
import { useAuth } from "react-oidc-context";
import FullscreenLoader from "./components/FullScreenLoader";

function RequireAuth({ children }) {
  const auth = useAuth();

  if (auth.isLoading) return <FullscreenLoader text="Loading..." />;
  if (!auth.isAuthenticated) {
    auth.signinRedirect();
    return null;
  }

  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/openid/auth" element={<Auth />} />
          <Route path="/dealerOn" element={
            <RequireAuth>
              <DealerOn />
            </RequireAuth>
          } />
          <Route path="*" element={<NoMatch />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}